import cookie from 'js-cookie';
import format from './format';

// const locales = {
//   'en-US': require('./lang/en').default,
//   'es-ES': require('./lang/es').default,
//   'de-DE': require('./lang/de').default,
//   'fr-FR': require('./lang/fr').default,
//   'jp-JP': require('./lang/ja').default,
//   'pt-PT': require('./lang/pt').default,
//   'ru-RU': require('./lang/ru-RU').default,
//   'zh-CN': require('./lang/zh-CN').default,
//   'zh-TW': require('./lang/zh-TW').default,
//   'ko-KO': require('./lang/ko').default
// };
export const locale = window.__global_lang__ || cookie.get('_zm_lang') || 'en-US';

const REG_MULTI = /[\w\u007f-\uFFEF\{\}]+(\s*\|\s*[\w\u007f-\uFFEF\{\}]+)+/;

let lang = {};

export const t = function(path, number, options) {
  if (!options && number) {
    options = number;
  }
  let value;
  const array = path.split('.');
  let current = lang;

  for (let i = 0, j = array.length; i < j; i++) {
    const property = array[i];
    value = current[property];

    if (i === j - 1) {
      if (REG_MULTI.test(value) && typeof number === 'number') {
        value = value.split('|')[number].trim();
      }

      return format(value, options);
    }
    if (!value) return '';
    current = value;
  }
  return '';
};

export function addLang(msg) {
  lang = Object.assign({}, lang, msg);
}

// const use = function(l) {
//   lang = l || lang;
// };

function install(Vue, options) {
  // noop function
  // use(l);
}

export function shouldIgnoreUnit() {
  return locale.indexOf(['jp-JP', 'ko-KO', 'zh-CN', 'zh-TW']) > -1;
}

export default { install };
